import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';
import { CreateTaskInput, DeleteTaskInput, Task, UpdateTaskInput } from '../types/task';

const task = gql`
  fragment Task on Task {
    id
    version
    companyId
    createdAt
    createdBy
    stockLocationId
    assignedTo
    assignedForRecount
    status
    type
    identifiers {
      type
      ids
    }
    parentId
    parentType
    externalReferenceId
    dueDate
    completedOn
    overdue
    additionalEmails
    number
    validation {
      quantity
      validationFields
    }
  }
`;

const get = gql`
  query Tasks($page: Float) {
    tasks(page: $page) {
      data {
        ...Task
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${task}
`;

export interface GetTasksVariables {
  page?: number;
}

export interface GetTasksResponse {
  tasks: PaginatedTasks;
}

class PaginatedTasks extends forPaginated<Task>() {}

const create = gql`
  mutation CreateTask($tasks: [CreateTaskInput!]!) {
    createTask(tasks: $tasks) {
      ...Task
    }
  }
  ${task}
`;

export interface CreateTaskVariables {
  tasks: CreateTaskInput[];
}

export interface CreateTaskResponse {
  createTask: Task[];
}

const updateAssignees = gql`
  mutation UpdateTaskAssignees($task: UpdateTaskInput!) {
    updateTaskAssignees(task: $task) {
      ...Task
    }
  }
  ${task}
`;

export interface UpdateTaskAssigneesVariables {
  task: UpdateTaskInput;
}

export interface UpdateTaskAssigneesResponse {
  updateTaskAssignees: Task;
}

const remove = gql`
  mutation DeleteTask($tasks: [DeleteTaskInput!]!) {
    deleteTask(tasks: $tasks) {
      ...Task
    }
  }
  ${task}
`;

export interface DeleteTaskVariables {
  tasks: DeleteTaskInput[];
}

export interface DeleteTaskResponse {
  deleteTask: Task[];
}

const process = gql`
  mutation ProcessTask($taskId: String!) {
    processTask(taskId: $taskId) {
      ...Task
    }
  }
  ${task}
`;

export interface ProcessTaskVariables {
  taskId: string;
}

export interface ProcessTaskResponse {
  processTask: Task;
}

export const TaskQueries = {
  get,
};

export const TaskMutations = {
  create,
  updateAssignees,
  remove,
  process,
};

export const TaskFragments = {
  task,
};
